const data = [
    { id: 1, name: "Catraca" },
    { id: 2, name: "Leitor biométrico" },
    { id: 3, name: "Central" },
    { id: 4, name: "Leitor facial" },
]

export default [...data]